<template>
        <v-row no-gutters>
            <v-col class=" pl-2 pb-2 pt-2">
                <v-chip outlined :small="$vuetify.breakpoint.smAndDown" v-for="(site) in selectedSites" :key="site" close close-icon="close" @click:close="selectSite(parseInt(site))" color="primary" class=" ma-1">
                    <span style="text-transform: capitalize" v-if="sitesFilter.find(s => site == s.id)">
                        {{ sitesFilter.find(s => site == s.id).name }}
                    </span>
                </v-chip>
                <v-chip outlined :small="$vuetify.breakpoint.smAndDown" v-for="(brand, i) in selectedBrands" :key="i" close close-icon="close" @click:close="selectBrand(brandsFilter.find(b => brand == b.id.Base64Guid))" color="primary" class=" ma-1">
                    <span style="text-transform: capitalize" v-if="brandsFilter.find(b => brand == b.id.Base64Guid)">
                        {{ brandsFilter.find(b => brand == b.id.Base64Guid).title }}
                    </span>
                </v-chip>
                <v-chip outlined :small="$vuetify.breakpoint.smAndDown" v-for="(serie, i) in selectedSeries" :key="i" close close-icon="close" @click:close="selectSerie(serie, allSeries.find(s => serie == s.id.Base64Guid).brandId.Base64Guid)" color="primary" class=" ma-1">
                    <span style="text-transform: capitalize" v-if=" allSeries.find(s => serie === s.id.Base64Guid)">
                        {{ allSeries.find(s => serie == s.id.Base64Guid).title }}
                    </span>
                </v-chip>
                <v-chip outlined :small="$vuetify.breakpoint.smAndDown" v-for="(mcat, i) in selectedMCategory" :key="i" close close-icon="close" @click:close="selectMainCategory(allCategoriesByRoute.find(mc => mcat == mc.title.toLowerCase()))" color="primary" class=" ma-1">
                    <span style="text-transform: capitalize" v-if="allCategoriesByRoute.find(mc => mcat == mc.title.toLowerCase())">
                    {{ allCategoriesByRoute.find(mc => mcat == mc.title.toLowerCase()).title}}
                    </span>
                </v-chip>
                 <v-chip outlined :small="$vuetify.breakpoint.smAndDown" v-for="(cat, i) in selectedCategory" :key="i" close close-icon="close" @click:close="selectCategory(getCategoryById(cat), getCategoryParentById(cat))" color="primary" class=" ma-1">
                    <span style="text-transform: capitalize" v-if="allCategoriesByRoute.find(c => cat == c.id)">
                    {{ allCategoriesByRoute.find(c => cat == c.id).title}}
                    </span>
                    <span style="text-transform: capitalize" v-else-if="allChildCategories.find(c=> cat == c.id) && allChildCategories.length">
                        {{allChildCategories.find(c=> cat == c.id).title}}
                    </span>
                </v-chip>
                 <!-- <v-chip :small="$vuetify.breakpoint.smAndDown" v-for="(cat, i) in selectedCategory" close close-icon="close" @click:close="selectCategory(getCategoryById(cat), getCategoryParentById(cat))" color="primary" class="secondary--text ma-1">
                    <span style="text-transform: capitalize" v-if="allCategoriesByRoute.find(c => cat == c.id)">
                    {{ allCategoriesByRoute.find(c => cat == c.id).title}}
                    </span>
                    <span style="text-transform: capitalize" v-else-if="allChildCategories.find(c=> cat == c.id) && allChildCategories.length">
                        {{allChildCategories.find(c=> cat == c.id).title}}
                </span>
                </v-chip> -->
                 <!-- <v-chip :small="$vuetify.breakpoint.smAndDown" v-if="selectedCampaign" @click:close="goToAllProducts" close close-icon="close" color="primary" class="secondary--text ma-1">
                   {{selectedCampaign.campaignName}}
                </span> -->
                <!-- </v-chip> -->
            </v-col>
        </v-row>
</template>
<script>
import webshopMixins from '@/components/webshop/cart/webshop.mixins'
import { mapWaitingActions } from "vue-wait";

export default {
    mixins: [webshopMixins],
    computed:{
        selectedSites() {
            let availableSites = this.sitesFilter.map(s => parseInt(s.id))
            if(this.$route.query.site && this.$route.query.site.length){
                if(typeof(this.$route.query.site) ===  'string'){
                    if(availableSites.includes(parseInt(this.$route.query.site))){
                        return [this.$route.query.site]
                    }
                }else {
                    return this.$route.query.site.filter(site => {
                        if(availableSites.includes(parseInt(site))){
                            return site
                        }
                    })
                }
            } else {
                return []
            }
        },
        selectedBrands(){
            let availableBrands = this.brandsFilter.map(b =>  b.id.Base64Guid)
            if(this.$route.query.brand && this.$route.query.brand.length){
                if(typeof(this.$route.query.brand) ===  'string'){
                    if(availableBrands.includes(this.$route.query.brand)){
                        return [this.$route.query.brand]
                    }
                }else {
                    return this.$route.query.brand.filter(brand => availableBrands.includes(brand))
                }
            } else {
                return []
            }
        },
        selectedSeries(){
            let availableSeries = this.allSeries.map(s => s.id.Base64Guid)
            if(this.$route.query.serie && this.$route.query.serie.length){
                if(typeof(this.$route.query.serie) ===  'string'){
                    if(availableSeries.includes(this.$route.query.serie)){
                        return [this.$route.query.serie]
                    }
                }else {
                    return this.$route.query.serie.filter(serie => availableSeries.includes(serie))
                }
            } else {
                return []
            }
        },
        selectedMCategory(){
            let availableCategories = this.allCategoriesByRoute.map(c => c.title.toLowerCase())
            if(this.$route.query.mCategory && this.$route.query.mCategory.length){
                if(typeof(this.$route.query.mCategory) ===  'string'){
                    if(availableCategories.includes(this.$route.query.mCategory)){
                        return [this.$route.query.mCategory]
                    }
                }else {
                    return this.$route.query.mCategory.filter(category => availableCategories.includes(category))
                }
            } else {
                return []
            }
        },
        selectedCategory(){
            let availableCategories = this.allCategoriesByRoute.map(c => parseInt(c.id))
            if(this.$route.query.category && this.$route.query.category.length){
                if(typeof(this.$route.query.category) ===  'string'){
                    if(availableCategories.includes(parseInt(this.$route.query.category)))
                    return [this.$route.query.category]
                }else {
                    return this.$route.query.category.filter(category => availableCategories.includes(parseInt(category)))
                }
            } else {
                return []
            }
        },
        allChildCategories(){
            let children = []
            this.allCategoriesByRoute.forEach(c=>{
                c.children.forEach(ch=>{
                    children.push(ch)
                })
            })
            return children
        }
    },
    methods:{
        ...mapWaitingActions("webshop", {
        getProducts: "loading webshop getProducts",
      }),
        getCategoryById(categoryId){
            let category = this.allCategoriesByRoute.find(c => categoryId == c.id) ? this.allCategoriesByRoute.find(c => categoryId == c.id) : this.allChildCategories.find(c=> categoryId == c.id)
            return category
        },
        getCategoryParentById(categoryId){
            let category = this.allCategoriesByRoute.find(c => categoryId == c.id) ? this.allCategoriesByRoute.find(c => categoryId == c.id) : this.allChildCategories.find(c=> categoryId == c.id)
            return this.allCategoriesByRoute.find(c => c.id === category.parentCategoryId)
        },
    }
}
</script>